// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1132":"4d5355c8","5285":"bb77da26","6506":"22dd3726","7199":"73cbfd06","8681":"a1034c9e"}[chunkId] + ".chunk.css";
};